var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconHome = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    viewBox: "0 0 16 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8E8E8E",
    d: "M15.746 7.61L8.346.564c-.193-.184-.499-.184-.692 0L.247 7.617c-.157.156-.247.37-.247.59 0 .456.374.828.833.828H2v6.291c0 .548.448.994 1 .994h2.833c.276 0 .5-.223.5-.497v-4.305c0-.09.075-.165.167-.165h3c.091 0 .167.074.167.165v4.305c0 .274.224.497.5.497H13c.552 0 1-.446 1-.994V9.035h1.167c.459 0 .833-.372.833-.828 0-.22-.09-.434-.254-.597z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V15.894H0z",
    transform: "translate(0 .426)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconHome, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_home.2d017fb8.svg";
export { ForwardRef as ReactComponent };